/** Account type key for income accounts in structure and search APIs. */
export const INCOME_ACCOUNT_TYPE = "הכנסה" as const;

/** Base route path for the incomes browse page. */
export const INCOMES_PATH = "/incomes";

/** Default breadcrumb labels for the incomes section. */
export const INCOMES_BREADCRUMB = {
  ledger: "כרטסות",
  list: "הכנסות",
} as const;

/** Breadcrumb labels for structure editor sub-pages. */
export const INCOMES_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;

/** Inline styles for the search filters panel on the incomes page. */
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
